export const slugify = string => {
  if (!string) return null;

  const stripAccents = string => {
    const accents =
      "ÀÁÂÃÄÅĄàáâãäåąÒÓÔÕÕÖØòóôõöøÈÉÊËĘèéêëðęÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠŚšśŸÿýŽŹŻžźżŁłŃńàáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ";
    const fixes =
      "AAAAAAAaaaaaaaOOOOOOOooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNnSSssYyyZZZzzzLlNnaaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
    const split = accents.split("").join("|");
    const regex = new RegExp(`(${split})`, "g");

    const replacement = string => fixes[accents.indexOf(string)] || "";

    return string.replace(regex, replacement);
  };

  const getSafeRegexString = string =>
    string
      .split("")
      .map(char => `\\${char}`)
      .join("");

  const delimiter = "-";
  const safeDelimiter = getSafeRegexString(delimiter);
  const nonValidRegex = new RegExp(`[^a-z0-9${safeDelimiter}]+`, "g");
  const multipleDelimitersRegex = new RegExp(`${safeDelimiter}+`, "g");
  const leadingDelimiterRegex = new RegExp(`^${safeDelimiter}`, "g");
  const trailingDelimiterRegex = new RegExp(`${safeDelimiter}$`, "g");

  let newString = stripAccents(string)
    .trim()
    .toLowerCase()
    .replace(nonValidRegex, delimiter)
    .replace(multipleDelimitersRegex, delimiter)
    .replace(leadingDelimiterRegex, "")
    .replace(trailingDelimiterRegex, "");

  return newString;
};
